<template>
    <div>
        <h2>Bitte wähle deinen Vertrag</h2>
        <div class="ion-text-right ion-padding-top">
            <chat-radio-group
                v-model="answer"
                :radios="radios"
                :hideRadioValue="true"
                v-if="isVisible"
            />
            <div class="c-chatbubble ion-margin-top" v-if="answer">
                <ion-grid>
                    <ion-row class="ion-align-items-center">
                        <ion-col size="4">
                            <!-- TODO: Bilder definieren -->
                            <img
                                :src="
                                    require('@/assets/img/motives/' +
                                        motive +
                                        '.png')
                                "
                            />
                        </ion-col>
                        <ion-col size="8" class="ion-padding-left">
                            <b>{{ selectedContract.ContractIdFormatted }}</b>
                            <div>{{ selectedContract.Description }}</div>
                            <div v-html="contractDetailsHtml"></div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <div class="ion-text-left ion-padding-top">
                <h3>{{ manualText }}</h3>
                <ion-grid class="ion-padding-top">
                    <ion-row>
                        <ion-col size="10" offset="2">
                            <base-input
                                type="text"
                                id="polizzenversicherung"
                                v-model="manualAnswer"
                                label="Polizzennummer"
                            ></base-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <ion-button
                class="-round -add-padding ion-margin-top"
                :disabled="answer === '' && manualAnswer === ''"
                @click="
                    $emit('change', [
                        {
                            id: 'polizzenversicherung',
                            value: answer || manualAnswer,
                        },
                    ])
                "
                >Weiter</ion-button
            >
        </div>
    </div>
</template>

<script>
import ChatRadioGroup from "@/components/ChatRadioGroup";
import BaseInput from "@/components/BaseInput";

export default {
    components: {
        ChatRadioGroup,
        BaseInput,
    },
    props: {
        feature: {
            required: true,
            type: String,
        },
        additionalFeatures: {
            required: false,
            type: Array,
            default: () => {
                return [];
            },
        },
        isVisible: {
            required: false,
            type: Boolean,
            default: true,
        },
        manualText: {
            required: false,
            type: String,
            default: "oder gib hier deine Wüstenrot Versicherungspolizze an",
        },
    },
    data() {
        return {
            answer: "",
            manualAnswer: "",
        };
    },
    watch: {
        contractsForFeature() {
            this.checkContractDetails();
        },
        answer(val) {
            if (val !== "") {
                this.manualAnswer = "";
            }
        },
        manualAnswer(val) {
            if (val !== "") {
                this.answer = "";
            }
        },
    },
    mounted() {
        this.checkContractDetails();
    },
    computed: {
        contractDetailsHtml() {
            let result = "";
            if (this.selectedContract.Sparte === "KFZ") {
                result =
                    this.selectedContractDetails.KfzBezeichnung +
                    "<br />" +
                    this.selectedContractDetails.KfzKennzeichen;
            } else if (this.selectedContract.Sparte === "EigenheimHaushalt") {
                result = this.selectedContractDetails.Risikoadresse;
            }
            return result;
        },
        contractsForFeature() {
            let result = {};
            const contracts = this.$store.state.contracts;
            for (let key in contracts) {
                if ("Features" in contracts[key]) {
                    if (this.feature in contracts[key].Features) {
                        result[key] = contracts[key];
                    } else {
                        for (let additionalFeature of this.additionalFeatures) {
                            if (additionalFeature in contracts[key].Features) {
                                result[key] = contracts[key];
                                break;
                            }
                        }
                    }
                }
            }
            return result;
        },
        radios() {
            let result = [];
            for (let key in this.contractsForFeature) {
                let contract = this.contractsForFeature[key];
                let description =
                    contract.Name + "<br>" + contract.ContractIdFormatted;
                if (contract.Sparte === "KFZ") {
                    description +=
                        "<br>" +
                        this.getBrand(key) +
                        " " +
                        this.getLicensePlate(key);
                }
                result.push({
                    value: key,
                    description: description,
                });
            }
            return result;
        },
        selectedContract() {
            let result = {};
            if (this.$store.state.contracts[this.answer]) {
                result = this.$store.state.contracts[this.answer];
            }
            return result;
        },
        selectedContractDetails() {
            let result = {};
            if (this.$store.state.contractsDetails.all[this.answer]) {
                result = this.$store.state.contractsDetails.all[this.answer];
            }
            return result;
        },
        motive() {
            // default motive
            let motive = "allgemein";
            const contractId = this.selectedContract.ContractId;
            if (
                contractId !== "" &&
                "Motives" in this.$store.state.contracts[contractId]
            ) {
                let motives = this.$store.state.contracts[contractId].Motives;
                let motiveKey = Object.keys(motives)[0];
                let motiveValue = motives[motiveKey];
                let motivesConfig = this.$store.state.motivesConfig;
                for (let motiveConfigKey in motivesConfig) {
                    if (motiveValue === motivesConfig[motiveConfigKey].motive) {
                        motive = motivesConfig[motiveConfigKey].path;
                        break;
                    }
                }
            }
            return motive;
        },
    },
    methods: {
        checkContractDetails() {
            for (let contractKey in this.contractsForFeature) {
                let contract = this.contractsForFeature[contractKey];
                if (
                    (contract.Sparte === "KFZ" ||
                        contract.Sparte === "EigenheimHaushalt") &&
                    !this.$store.state.contractsDetails.all[contractKey]
                ) {
                    this.$store.cache.dispatch(
                        "contractsDetails/getContractDetails",
                        contractKey
                    );
                }
            }
        },
        getAddress(contractId) {
            let result = "";
            const constractsDetails = this.$store.state.contractsDetails;
            if (
                constractsDetails.all[contractId] &&
                constractsDetails.all[contractId].Risikoadresse
            ) {
                result = constractsDetails.all[contractId].Risikoadresse;
            }
            return result;
        },
        getLicensePlate(contractId) {
            let result = "";
            const constractsDetails = this.$store.state.contractsDetails;
            if (
                constractsDetails.all[contractId] &&
                constractsDetails.all[contractId].KfzKennzeichen
            ) {
                result = constractsDetails.all[contractId].KfzKennzeichen;
            }
            return result;
        },
        getBrand(contractId) {
            let result = "";
            const constractsDetails = this.$store.state.contractsDetails;
            if (
                constractsDetails.all[contractId] &&
                constractsDetails.all[contractId].KfzMarke
            ) {
                result = constractsDetails.all[contractId].KfzMarke;
            }
            return result;
        },
    },
};
</script>

<style></style>
